import api from "./interceptor";

const getAllLeaves = () => api.get(`/leaves`);
const getUserLeaves = (userId) => api.get(`/leaves/user/${userId}`);
const applyLeave = (data) => api.post(`/leaves`, data);
const updateLeaveStatus = (id, data) => api.put(`/leaves/${id}/status`, data);
const deleteLeave = (id) => api.delete(`/leaves/${id}`);

export { getAllLeaves, getUserLeaves, applyLeave, updateLeaveStatus, deleteLeave };
